export const getAllContests = () => `concourse/concourse/`